<template>
  <CCard class="dataTable py-5 mt-3">
    <CRow class="pt-5 pb-4">
      <CCol sm="12" class="d-flex flex-column">
        <div>
          <h2 class="titlePage font-weight-normal text-capitalize">
            {{ $t('transaction.history.text.title') }}
          </h2>
        </div>
      </CCol>
    </CRow>
    <CCardHeader class="dataTable__header px-0 w-100">
      <CRow>
        <CCol sm="12" md="11" lg="10">
          <div class="dataTable__countContants d-flex content-center justify-content-start">
            <multiselect
              class="d-inline-block multiselect--custom z4 mr-3"
              v-model="periodType"
              :multiple="false"
              :options="periodOptions"
              custom
              style="width: 230px; z-index: 5; max-height: 45px"
              :allow-empty="false"
              :show-labels="false"
              label="label"
              @input="selectDateFilterType"
              @open="openPeriod"
              @close="closePeriod"
            />
            <transition name="fade" v-if="datePopup">
              <div class="dataTable__popUp popUp" style="width: 323px" @click.stop.stop>
                <div class="popUp__body shadow-sm">
                  <v-date-picker
                    mode="range"
                    is-range
                    color="purple"
                    v-model="dateRange"
                    is-inline
                    addInputClasses="p-5 date-picker__input"
                    @input="inputPeriod()"
                  >
                  </v-date-picker>
                  <div class="blocker" @click="closePopupDate"></div>
                </div>
              </div>
            </transition>

            <multiselect
              class="d-inline-block multiselect--custom z4"
              v-model="type"
              multiple
              :options="typeOptions"
              custom
              style="width: 60%; z-index: 5"
              :show-labels="false"
              :preselect-first="true"
              track-by="value"
              label="label"
              @input="selectFilterType"
            />
          </div>
        </CCol>
        <CCol sm="12" md="1" lg="2" class="">
          <div class="dataTable__buttonLink">
            <button class="btn btn-white px-4 py-2 font-weight-bold text-gray-600" style="width: 180px" tag="button" @click="showPopupExport">
              {{ $t('transaction.history.button.export') }}
              <CIcon name="arrowExport" size="custom-size" :height="18" class="ml-2" viewBox="0 0 32 32" />
            </button>
            <transition name="fade" v-if="exportPopup">
              <div class="dataTable__popUp popUp" @click.stop.stop>
                <div class="popUp__body shadow-sm">
                  <ChooseExport @confirm="exportRecods($event)" @cancel="closePopupExport" />
                  <div class="blocker" @click="closePopupExport"></div>
                </div>
              </div>
            </transition>
          </div>
        </CCol>
      </CRow>
    </CCardHeader>

    <template v-if="totalRecords == 0 && firstLoading">
      <EmptyList :loading="loadingGetList" :title="$t('transaction.history.text.noTransactions')" />
    </template>

    <template v-if="!firstLoading">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CCardBody class="dataTable__body p-0 data_table_transactions">
        <CDataTable
          :items="registers"
          :fields="headers"
          :table-filter="{ external: true, lazy: true }"
          items-per-page-select
          :items-per-page.sync="itemsPerPage"
          @pagination-change="paginationChange"
          :active-page="1"
          hover
          :loading="loading"
        >
          <template #loading>
            <div class="d-flex justify-content-center align-items-center dataTable__loading">
              <CSpinner class="my-3" color="primary" />
            </div>
          </template>

          <template #dateTime="{ item }">
            <td class="text-left py-4">
              {{ formatDate(item.dateTime) }}
            </td>
          </template>

          <template #createdBy="{ item }">
            <td class="text-left py-4">
              {{ item.createdBy }}
            </td>
          </template>

          <template #typeName="{ item }">
            <td class="text-left py-4">
              {{ $t(`transaction.history.typeName.${item.typeName}`) }}
            </td>
          </template>

          <template #channel="{ item }">
            <td class="text-left py-4" v-if="item.channel == 'Sms'">
              {{ item.countryId ? `${item.channel} - ${item.countryId}` : item.channel }}
            </td>
            <td class="text-left py-4" v-else>
              {{ item.channel }}
            </td>
          </template>

          <template #transactionAmount="{ item }">
            <td
              class="text-left py-4"
              :class="
                item.typeName != 'TAKE' &&
                item.typeName != 'CAMPAIGN' &&
                item.typeName != 'AUTOMATION' &&
                item.typeName != 'TRANSACTIONAL' &&
                item.typeName != 'MO_RESPONSE'
                  ? 'text-success'
                  : 'text-danger'
              "
            >
              {{
                item.typeName != 'TAKE' &&
                item.typeName != 'CAMPAIGN' &&
                item.typeName != 'AUTOMATION' &&
                item.typeName != 'TRANSACTIONAL' &&
                item.typeName != 'MO_RESPONSE'
                  ? '+'
                  : '-'
              }}
              {{ item.transactionAmount | numberWithCommas }}
            </td>
          </template>

          <template #balance="{ item }">
            <td class="text-left py-4">
              <span v-if="organizationBalanceConfigType === organizationBalanceConfigTypes.NO_OWN_BALANCE" class="text-warning">
                {{ $t('transaction.history.transaction-amount.not-available') }}
              </span>
              <span v-else>{{ item.balance | numberWithCommas }}</span>
            </td>
          </template>

          <template #showDetails="{ item, index }">
            <td v-if="item.metaData" class="text-center py-4" @click="toggleDetails(item, index)">
              <span>
                <u class="text-uppercase">{{ $t('transaction.history.text.details') }}</u>
                <CIcon name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </span>
            </td>
            <td v-else class="text-center py-4"></td>
          </template>

          <template #details="{ item }">
            <CCollapse :show="Boolean(item._toggled)" class="bg-gray-200 text-gray-600" style="cursor: default">
              <div class="px-4 py-3">
                <div style="display: flex; height: 30px; position: relative; align-items: bottom">
                  <div class="mr-2">
                    <CIcon name="infoSquareFull" size="custom-size" :height="18" viewBox="0 0 32 32" />
                  </div>
                  <div class="pt-1">
                    {{ $t('transaction.history.text.descriptionObservation') }}
                  </div>
                </div>
                <div class="text-sm mt-2 description-details" v-if="item.typeName != 'CAMPAIGN'">
                  {{ showItemText(item.metaData) }}
                </div>
                <div class="text-sm mt-2 description-details" v-if="item.typeName == 'CAMPAIGN'">
                  {{ $t('transaction.history.text.campaingDescrition') }}
                  <b>{{ getCampaignName(item.metaData) }}</b>
                </div>
                <div class="text-sm mt-2 description-details" v-if="item.typeName == 'AUTOMATION'">
                  {{ $t('transaction.history.text.automationDescription') }}:
                  <b>{{ getAutomationName(item.metaData) }}</b>
                </div>
              </div>
            </CCollapse>
          </template>
        </CDataTable>
      </CCardBody>

      <div class="position-relative">
        <CPagination
          v-show="pages > 0 && totalRecords > 0"
          align="center"
          :pages="pages"
          :active-page.sync="activePage"
          class="dataTable__newPagination mt-3"
        >
          <template slot="previous-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.prev') }}
            </span>
          </template>
          <template slot="next-button">
            <span class="newPagination__button p-2 btnPagination">
              {{ $t('audience.audienceList.text.next') }}
            </span>
          </template>
        </CPagination>
        <CElementCover v-if="loading" :opacity="0.8" style="z-index: 1001">
          <div></div>
        </CElementCover>
      </div>
    </template>
  </CCard>
</template>

<script>
const headerLabel = [
  { key: 'dateTime', label: 'DATE' },
  { key: 'createdBy', label: 'USER' },
  { key: 'typeName', label: 'ACTION' },
  { key: 'channel', label: 'CHANNEL' },
  { key: 'transactionAmount', label: 'VALUE' },
  { key: 'balance', label: 'BALANCE' },
  {
    key: 'showDetails',
    label: '',
    _classes: 'hidde',
    _style: 'width:150px',
  },
]

import HeaderActions from '@/components/table/HeaderActions'
import MenssageAlert from '@/components/MenssageAlert'
import { dateTimeFormatString } from '../../../utils/dateUtil'
import { getFilenameFromContentDisposition } from '../../../utils/responseHeaderUtils'
import EmptyList from '@/components/EmptyList'
import services from '@/services.js'
import ChooseExport from '@/components/ChooseExport'
import fileDownload from 'js-file-download'
export default {
  name: 'TransactionHistoryList',
  components: {
    MenssageAlert,
    HeaderActions,
    EmptyList,
    ChooseExport,
  },
  data() {
    return {
      loadingGetList: false,
      columnFilterValue: {},
      loadedItems: [],
      loading: false,
      firstLoading: true,
      itemsPerPage: 10,
      pages: 0,
      headers: [],
      totalPendings: 0,
      totalRecords: 0,
      itemsListSelected: null,
      activePage: 1,
      messages: [],
      collapseDuration: 0,
      pagination: [],
      periodAux: null,
      periodType: { value: 1, label: '1 Month' },
      filters: {
        period: 1,
        TransactionType: [1, 2, 3, 4],
        count: 10,
        page: 1,
      },
      dateRange: null,
      type: [
        { value: 1, label: this.$t('general.table.header.purchases') },
        { value: 2, label: this.$t('general.table.header.grant') },
        { value: 3, label: this.$t('general.table.header.take') },
        { value: 4, label: this.$t('general.table.header.campaign') },
      ],
      periodOptions: [
        { value: 1, label: this.$t('transaction.history.periodType.1') },
        { value: 3, label: this.$t('transaction.history.periodType.3') },
        { value: 6, label: this.$t('transaction.history.periodType.6') },
        { value: 12, label: this.$t('transaction.history.periodType.12') },
        { value: null, label: this.$t('transaction.history.periodType.null') },
      ], // ['1 Month', '3 Month', '6 Month', '12 Month', 'Search for dates'],
      typeOptions: [
        { value: 1, label: this.$t('general.table.header.purchases') },
        { value: 2, label: this.$t('general.table.header.grant') },
        { value: 3, label: this.$t('general.table.header.take') },
        { value: 4, label: this.$t('general.table.header.campaign') },
        { value: 5, label: this.$t('general.table.header.transactional') },
        { value: 6, label: this.$t('general.table.header.automation') },
        { value: 7, label: this.$t('general.table.header.2way-messaging') },
      ], // ['All', 'Assignments', 'Campaigns', 'Purchases'],
      exportPopup: false,
      datePopup: false,
      organizationBalanceConfigType: null,
      organizationBalanceConfigTypes: Object.freeze({
        NO_OWN_BALANCE: 1,
        OWN_BALANCE_DEPENDENT: 2,
        OWN_BALANCE_INDEPENDENT: 3,
      }),
    }
  },

  created() {
    this.loadingGetList = true
    this.getData({
      page: this.activePage,
      count: this.itemsPerPage,
    })
  },
  watch: {
    reloadParams() {
      this.onTableChange()
    },
  },

  computed: {
    registers() {
      return this.loadedItems.map((transaction) => {
        return {
          ...transaction,
          _classes: [transaction._classes],
        }
      })
    },

    reloadParams() {
      return [this.activePage, this.itemsPerPage]
    },

    detailPagination() {
      const first = (this.activePage - 1) * this.itemsPerPage
      const totalPage = this.activePage * 10 > this.totalRecords ? this.totalRecords : this.activePage * 10
      return `${first} - ${totalPage}  of ${this.totalRecords}`
    },
  },

  methods: {
    selectDateFilterType() {
      this.periodAux = null
      if (this.periodType.value) {
        this.filters.period = this.periodType.value
        this.filters.InitialDate = this.filters.FinalDate = null

        this.getData()
      } else {
        this.filters.period = null
        this.datePopup = true
      }
    },

    openPeriod() {
      this.periodAux = JSON.parse(JSON.stringify(this.periodType))
      this.periodType = null
    },

    closePeriod() {
      if (this.periodAux) {
        this.periodType = Object.assign(this.periodAux)
      }
    },

    inputPeriod() {
      // this.filters.InitialDate = DateTime.fromJSDate(this.dateRange.start).toLocaleString()
      // this.filters.FinalDate = DateTime.fromJSDate(this.dateRange.end).toLocaleString()
      this.filters.InitialDate = new Date(this.dateRange.start.getTime() - this.dateRange.start.getTimezoneOffset() * 60000).toISOString()
      this.filters.FinalDate = new Date(this.dateRange.end.getTime() - this.dateRange.end.getTimezoneOffset() * 60000).toISOString()
      this.getData()
    },

    formatDate(date) {
      return date ? dateTimeFormatString(date) : ''
    },

    headerHandle() {
      return [
        { key: 'dateTime', label: this.$t('general.table.header.date') },
        { key: 'createdBy', label: this.$t('general.table.header.user') },
        { key: 'typeName', label: this.$t('general.table.header.action') },
        { key: 'channel', label: this.$t('general.table.header.channel') },
        { key: 'transactionAmount', label: this.$t('general.table.header.value') },
        { key: 'balance', label: this.$t('general.table.header.balance') },
        {
          key: 'showDetails',
          label: '',
          _classes: 'hidde',
          _style: 'width:150px',
        },
      ]
    },

    showPopupExport() {
      this.exportPopup = true
    },

    closePopupExport() {
      this.exportPopup = false
    },

    showPopupDate() {
      this.datePopup = true
    },

    closePopupDate() {
      this.datePopup = false
    },

    selectFilterType() {
      this.filters.TransactionType = this.type
        .map((element) => {
          if (element.value != null) return element.value
        })
        .filter((item) => item != undefined)

      this.getData()
    },
    exportRecods(events) {
      let organizationId = this.$route.params.organizationId
      let filters = this.filters
      delete filters.count
      delete filters.page

      filters.format = events.format
      filters.delimiter = events.delimiter

      services
        .getTransactionExport(organizationId, filters)
        .then((response) => {
          const nameFile = getFilenameFromContentDisposition(response.headers['content-disposition'])

          fileDownload(response.data, nameFile, response.headers['content-type'])
        })
        .catch((error) => {
          this.messages.push({
            status: 'danger',
            text: error.response.data.message || error.response.statusText,
          })
        })
    },

    mountItemsTable(arr) {
      return arr.reduce((acc, cur, index) => {
        acc.push({
          ...cur,
          _toggled: index == this.indexItemOpened ?? this.indexItemOpened != null ? true : false,
          index: index,
          _classes: [cur._selected ? 'table-selected' : null],
        })
        return acc
      }, [])
    },

    getData() {
      this.filters.page = this.activePage
      this.filters.count = this.itemsPerPage

      let organizationId = this.$route.params.organizationId

      this.loading = true
      services
        .getTransactions(organizationId, this.filters)
        .then((res) => {
          this.pages = Math.ceil(res.data.data.pagination.totalRecords / 10)
          this.totalRecords = res.data.data.pagination.totalRecords
          this.activePage = res.data.data.pagination.currentPage
          this.headers = this.headerHandle()
          this.loadedItems = this.mountItemsTable(res.data.data.transactions)
          this.organizationBalanceConfigType = res.data.data.organizationBalanceConfigType
          this.pagination = res.data.data.pagination
          this.loading = false

          if (this.firstLoading) {
            // No caso do primeiro carregamento, se for detectado que o total de registros
            // for maior que zero, vai dizer que já passou pelo primeiro carregamento
            // então a condição para a verificação abaixo não ocorrerá novamente
            this.firstLoading = !(this.totalRecords > 0)
          }
        })
        .catch((err) => {
          this.loadedItems = []
        })
        .finally(() => {
          this.loadingGetList = this.loading = false
        })
    },

    onTableChange(loading = true) {
      this.getData(
        {
          page: this.activePage,
          count: this.itemsPerPage,
        },
        loading,
      )
    },

    paginationChange(a) {
      this.itemsPerPage = a
    },

    chooseFilterBy(item) {
      this.SenderStatusId = null
      this.OrganizationStatusId = null

      if (item === 'all') {
        return
      }

      this[item.column] = item.value
    },

    toggleDetails(item, index) {
      this.$set(this.loadedItems[index], '_toggled', !item._toggled)
      this.indexItemOpened = !item._toggled ? index : null

      this.collapseDuration = 300
      this.$nextTick(() => {
        this.collapseDuration = 0
      })
    },

    showItemText(metadata) {
      if (metadata) {
        var obj = JSON.parse(metadata)
        return obj.Reason ?? ''
      }
      return ''
    },

    getCampaignName(item) {
      let obj = JSON.parse(item)
      return obj.CampaignDescription
    },

    getAutomationName(item) {
      let obj = JSON.parse(item)
      return obj.WorkflowDescription || '-'
    },
  },
}
</script>
<style scoped lang="scss">
.description-details {
  font-size: $font-size-xs;
}

.positive-value {
  color: $success;
}

.negative-value {
  color: $warning;
}

.listItem__download {
  cursor: pointer;
}

.listItem__name {
  flex: 0 0 20%;
  min-width: 250px;
}

.listItem__numbers {
  font-size: $font-size-xs;
  position: relative;
}

.listItem__detail {
  flex-wrap: wrap;
}
</style>
<style>
.data_table_transactions {
  background: transparent !important;
}

.data_table_transactions tbody tr {
  background: transparent !important;
  cursor: pointer;
  border-top: 1px solid #d1d4da;
  -webkit-transition: color 400ms, -webkit-box-shadow 400ms;
  transition: color 400ms, -webkit-box-shadow 400ms;
  transition: box-shadow 400ms, color 400ms;
  transition: box-shadow 400ms, color 400ms, -webkit-box-shadow 400ms;
  border-radius: 2px;
}

.data_table_transactions tbody tr:hover {
  background-color: transparent !important;
}

.blocker {
  z-index: -1;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  content: ' ';
  background: transparent;
}
</style>

<style module>
.blockClick {
  pointer-events: none;
}
</style>
